import Guid from "_shared/guids/guid";
import DocumentTopic from "documents/topics/document-topic";

export type BulkDocumentRequest = {
  requestId: Guid;
  file: File;
  name?: string | null;
  topics?: DocumentTopic[];
  templateIds?: Guid[];
};

export type BulkDocumentRequestOptions = {
  topics?: DocumentTopic[];
  templateIds?: Guid[];
  getName?: (file: File, index: number) => string | null | undefined;
};

export function createBulkDocumentRequests(
  files: File[],
  options?: BulkDocumentRequestOptions
): BulkDocumentRequest[] {
  return files.map((file, index) => ({
    requestId: Guid.generate(),
    file,
    name: options?.getName ? options.getName(file, index) : file.name,
    topics: options?.topics,
    templateIds: options?.templateIds,
  }));
}

export default class DocumentsFormAPIRequest {
  public formData: FormData;

  constructor(requests: BulkDocumentRequest[]) {
    this.formData = new FormData();
    requests.forEach((request, index) => {
      this.formData.append(`Documents[${index}].RequestId`, request.requestId.value);
      this.formData.append(`Documents[${index}].File`, request.file);
      if (request.name) {
        this.formData.append(`Documents[${index}].FileName`, request.name);
      }
      request.topics?.forEach((topic, topicIndex) => {
        this.formData.append(
          `Documents[${index}].Topics[${topicIndex}]`,
          JSON.stringify(topic.toJSON())
        );
      });
      request.templateIds?.forEach((templateId, templateIndex) => {
        this.formData.append(
          `Documents[${index}].TemplateIds[${templateIndex}]`,
          templateId.value
        );
      });
    });
  }
}
